import { graphql } from "@repo/graphql-types/gql";
import { useSearch } from "@tanstack/react-router";
import { formatDateAndTimeIgnoringTimezone, getCurrentDate } from "@repo/lib";
import { DownloadFileButton } from "@/components/download-file-button";
import { useGraphQL } from "@/hooks/use-graphql";
import { trackEvent } from "@/lib/tracking";

const BillingItemDetailsAssistDownloadQuery = graphql(/* GraphQL */ `
  query BillingItemDetailsAssistDownloadQuery($assistBillingBatchId: Int!) {
    NuntiusGetAssistContactBatchDetails(arg1: {
      contactBatchId: $assistBillingBatchId
    }) {
      assistContactBatchDetails {
        billingDate
        channel
        contactId
        contactReason
        contactType
        direction
        endDate
        patientName
        phoneNumber
        price
        startDate
      }
    }
  }
`);

export const BillingItemDetailsAssistDownloadButton = (): JSX.Element => {
  const { assistBillingBatchId } = useSearch({
    from: "/settings/billing/$billingItemId",
  });

  const queryResult = useGraphQL(BillingItemDetailsAssistDownloadQuery, {
    assistBillingBatchId: Number(assistBillingBatchId),
  });

  const { data } = queryResult;

  const getFileNameAndContent = (): {
    fileName: string;
    fileContent: string;
  } => {
    const csvRows = [];
    const headerRow = [
      "Codigo de contato",
      "Nome",
      "Telefone",
      "Data e hora inicio",
      "Data e hora fim",
      "Data da movimentacao",
      "Motivo do contato",
      "Canal",
      "Tipo de atendimento",
      "Iniciativa do contato",
      "Valor",
    ];
    csvRows.push(headerRow);

    const details =
      data?.NuntiusGetAssistContactBatchDetails?.assistContactBatchDetails ?? [];

    for (const item of details) {
      if (!item) continue;
      csvRows.push([
        item.contactId,
        item.patientName,
        item.phoneNumber,
        item.startDate,
        item.endDate,
        item.billingDate,
        item.contactReason,
        item.channel,
        item.contactType,
        item.direction,
        item.price,
      ]);
    }
    const fileContent = csvRows
      .map((row) => row.map((value) => `"${value}"`).join(","))
      .join("\n");

    const fileName = `contatos_atendidos_assist_${formatDateAndTimeIgnoringTimezone(
      getCurrentDate(),
      undefined,
      "dd-MM-yyyy",
    )}`;

    return { fileName, fileContent };
  };

  const { fileName, fileContent } = getFileNameAndContent();

  return (
    <div className="mt-6 w-full">
      <DownloadFileButton
        title="Baixar contatos atendidos"
        fileContent={fileContent}
        fileName={fileName}
        fileExtension="csv"
        rounded={false}
        size="default"
        Icon={() => undefined}
        loading={queryResult.isLoading}
        onClick={() => {
          trackEvent("Contatos atendidos baixados");
        }}
      />
    </div>
  );
};
